import React, { useEffect, useRef, useState } from "react";
import { default as infoIcon } from "../../assets/images/infobtnblue.svg";
import CKeditorComponent from "../common-component/CKeditorComponent";
import { Col, Form, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { API_URL } from "../../services/APIRoute";
import { apiResponse } from "../../services/APIResponse";
import { apiCall } from "../../services/AxiosService";
import { commonservices } from "../../services/CommonServices";
import { useDispatch } from "react-redux";
import {
  UpdateMachine,
  UpdateReviewComment,
} from "../../services/ReduxTookit/Slice/MachineRedux";
import SubmitLoading from "../common-component/Loaders/SubmitLoading";
import MainpageLoader from "../common-component/Loaders/MainpageLoader";
import { createPortal } from "react-dom";

const Specifications = ({
  getlist,
  handleclose,
  bindlist,
  versionlist,
  updatereviewcommentdata,
  geteditstatus,
  setmachinedetails,
}) => { 
  const countFalseValues = () => {
    return Object.values(geteditstatus).filter((value) => value === false)
      .length;
  };
  const InputFileRef = useRef();
  const OutputFileRef = useRef();

  const [input, setInput] = useState({
    machineid: 0,
    price: "",
    subcategoryid: 0,
    title: "",
    inputdescription: "",
    outputdescription: "",
    inputsamplefile: "",
    outputsamplefile: "",
    inputsamplename: "",
    outputsamplename: "",
    osrequirmet: "",
    storage: "",
    ram: "",
    cpu: "",
    compatiblemachineids: [],
    dependentmachineids: [],
    cloud: [],
    errors: {
      machineid: "",
      inputdescription: "",
      outputdescription: "",
      ValidationRules: [
        {
          FieldName: "inputdescription",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "outputdescription",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
      ],
    },
  });
  const [OutputSpecificationfile, setOutputSpecificationFile] = useState();
  const [InputSpecificationfile, setInputSpecificationFile] = useState();
  const [Pdffile, setPdfFile] = useState();
  const [MachineLoader, setMachineLoader] = useState(false);
  const dispatch = useDispatch();
  const updateReviewStatus = async (e) => {
    e.preventDefault();
    let obj = commonservices.fnCheckValidationOfObject(input);
    setInput({
      ...obj.obj,
    });
    if (obj.isValid) {
      setMachineLoader(true);
      let newbody = {
        machineid: versionlist?.machineid,
        versionnumber: versionlist?.number,
        booleanfield: updatereviewcommentdata?.booleanfield,
        commentfield: updatereviewcommentdata?.commentfield,
        commentfieldvalue: updatereviewcommentdata?.commentfieldvalue,
      };
      // let updateReviewResponse = await apiCall(
      //   {
      //     method: "POST",
      //     url: API_URL.BASEURL + API_URL.MACHINE.UPDATE_REVIEWR_COMMENT,
      //     body: newbody,
      //   },
      //   true
      // );
      // let response = apiResponse(false, updateReviewResponse);

      dispatch(UpdateReviewComment(newbody))?.then((response) => {
        if (response?.payload?.isValidate) {
          handleUpdate();
        }
        if (!response?.payload?.isValidate) {
        }
      });
    }
  };
  const handleUpdate = async () => {
    let body = {
      machineid: parseInt(input?.machineid),
      inputdescription: input?.inputdescription,
      outputdescription: input?.outputdescription,
      price: input?.price ? input?.price : 0,
      subcategoryid: input?.subcategoryid ? input?.subcategoryid : 0,
      title: input?.title ? input?.title : "",
      inputsamplefile: input?.inputsamplefile,
      outputsamplefile: input?.outputsamplefile,
      osrequirmet: input?.osrequirmet ? input?.osrequirmet : "",
      storage: input?.storage ? input?.storage : "",
      ram: input?.ram ? input?.ram : "",
      cpu: input?.cpu ? input?.cpu : "",
      cloud: input?.cloud ? input?.cloud : "",
      compatiblemachineids: input?.compatiblemachineids
        ? input?.compatiblemachineids
        : "",
      dependentmachineids: input?.dependentmachineids
        ? input?.dependentmachineids
        : "",
    };
    if (countFalseValues() === 1) {
      body = { ...body, status: "In Process" };
    } else {
      body = { ...body, status: "Rejected" };
    }
    // let resData = await apiCall(
    //   {
    //     method: "PUT",
    //     url: API_URL.BASEURL + API_URL?.MACHINE?.UPDATE_MACHINE,
    //     body: body,
    //   },
    //   true
    // );
    // let response = apiResponse(true, resData, setMachineLoader);
    // if (response?.isValidate) {
    //   handleclose();
    //   bindlist(input?.machineid);
    // }
    // if (!response?.isValidate) {
    //   setMachineLoader(false);
    // }
    dispatch(UpdateMachine(body))?.then((response) => {
      setMachineLoader(false);
      if (response?.payload?.isValidate) {
        setMachineLoader(false);
        handleclose();
          // bindlist(input?.machineid);
      const updatedMachineDetails = {
        ...getlist,
        dataList1: getlist?.dataList1?.map((item) => ({
          ...item,
          inputsamplefileurl: response?.payload?.data?.data?.machine?.inputsamplefile,
          outputsamplefileurl: response?.payload?.data?.data?.machine?.outputsamplefile,
        })),
        dataList2: getlist?.dataList2?.map((item) => ({
          ...item,
          inputdescription: input?.inputdescription,
          outputdescription: input?.outputdescription,
        })),
      };
      setmachinedetails(updatedMachineDetails);
      }
      if (!response?.payload?.isValidate) {
        setMachineLoader(false);
      }
    });
    // }
  };

  const fnCommonFileChange = async (mainfile, type, tag) => {
    if (!mainfile) return;
    if (mainfile?.type !== type) {
      return toast.error(`${`Only ${type} are allowed.`}`);
    }
    if (tag === "outputsamplefile") {
      setInput({
        ...input,
        [tag]: mainfile,
        ["outputsamplename"]: mainfile?.name,
        errors: {
          ...input.errors,
          [tag]: "",
        },
      });
      setOutputSpecificationFile(URL.createObjectURL(mainfile));
    } else if (tag === "inputsamplefile") {
      setInput({
        ...input,
        [tag]: mainfile,
        ["inputsamplename"]: mainfile?.name,
        errors: {
          ...input.errors,
          [tag]: "",
        },
      });
      setInputSpecificationFile(URL.createObjectURL(mainfile));
    } else if (tag === "machinedocument") {
      setPdfFile(URL.createObjectURL(mainfile));
    }
  };
  const handleCKEditor = (content, tag) => {
    setInput({
      ...input,
      [tag]: content,
      errors: {
        ...input.errors,
        [tag]: "",
      },
    });
  };

  useEffect(() => {
    if (getlist) {
      setInput({
        ...input,
        machineid: getlist?.dataList1[0]?.machineid
          ? getlist?.dataList1[0]?.machineid
          : 0,
        price: getlist?.dataList1[0]?.price ? getlist?.dataList1[0]?.price : "",
        subcategoryid: getlist?.dataList1[0]?.subcategoryid
          ? getlist?.dataList1[0]?.subcategoryid
          : 0,
        title: getlist?.dataList2[0]?.title ? getlist?.dataList2[0]?.title : "",
        inputdescription: getlist?.dataList2[0]?.inputdescription
          ? getlist?.dataList2[0]?.inputdescription
          : "",
        outputdescription: getlist?.dataList2[0]?.outputdescription
          ? getlist?.dataList2[0]?.outputdescription
          : "",
        inputsamplename: getlist?.dataList1[0]?.inputsamplefile
          ? getlist?.dataList1[0]?.inputsamplefile
          : "",
        outputsamplename: getlist?.dataList1[0]?.outputsamplefile
          ? getlist?.dataList1[0]?.outputsamplefile
          : "",
        inputsamplefile: "",
        outputsamplefile: "",
        osrequirmet: getlist?.dataList2[0]?.osrequirmet
          ? getlist?.dataList2[0]?.osrequirmet
          : "",
        storage: getlist?.dataList2[0]?.storage
          ? getlist?.dataList2[0]?.storage
          : "",
        ram: getlist?.dataList2[0]?.ram ? getlist?.dataList2[0]?.ram : "",
        cpu: getlist?.dataList2[0]?.cpu ? getlist?.dataList2[0]?.cpu : "",
        cloud: getlist?.dataList2[0]?.cloud ? getlist?.dataList2[0]?.cloud : "",
        compatiblemachineids: getlist?.dataList2[0]?.compatiblemachineids
          ? getlist?.dataList2[0]?.compatiblemachineids
          : [],
        dependentmachineids: getlist?.dataList2[0]?.dependentmachineids
          ? getlist?.dataList2[0]?.dependentmachineids
          : [],
      });
    }
  }, [getlist]);

  // Add or remove 'loadtime' class based on MachineLoader

 useEffect(() => {
  if (MachineLoader) {
    document.body.classList.add('loadtime');
  } 
  // else {
  //   document.body.classList.remove('loadtime');
  // }

  // Cleanup when component unmounts
  return () => {
    document.body.classList.remove('loadtime');
  };
}, [MachineLoader]); // Re-run this effect when MachineLoader changes
const LoaderPortal = ({ children }) => {
  return createPortal(children, document.body);
};

  return (
    <div>
      {MachineLoader && (
        <LoaderPortal>
          <MainpageLoader />
        </LoaderPortal>
      ) }

      <Col md={12}>
        <Form.Group className="mb-3" controlId="formProfilePic">
          <Form.Label className="common-label">
            Upload Input Sample Data (json file)
            <span className="ms-1 red-color-text">*</span>
          </Form.Label>
          <div className="position-relative">
            <div
              className={`file-input height-40 ${
                input.errors.inputsamplefile && "error-border-line"
              }`}
            >
              <label
                className="filelabel-browse-file w-100"
                for="inputsamplefile"
              >
                <div className="filelabel-browse-file-inner">
                  <span>
                    {input?.inputsamplename
                      ? input?.inputsamplename
                      : "Json File"}
                  </span>
                  <div className="browse-btn-in-input">Browse</div>
                </div>
                <input
                  id="inputsamplefile"
                  type="file"
                  ref={InputFileRef}
                  accept="application/json"
                  onChange={(e) =>
                    fnCommonFileChange(
                      e.target.files[0],
                      "application/json",
                      "inputsamplefile"
                    )
                  }
                />
              </label>
            </div>
            {input.errors.inputsamplefile && (
              <p className="error-line">
                <span className="error-message-icon">
                  <img
                    src={infoIcon}
                    alt="infoIcon"
                    title={input.errors.inputsamplefile}
                  />
                </span>
              </p>
            )}
          </div>
        </Form.Group>
      </Col>
      <Col md={12}>
        <Form.Group className="mb-3" controlId="formProfilePic">
          <Form.Label className="common-label">
            Input Specifications<span className="ms-1 red-color-text">*</span>
          </Form.Label>
          <div className="position-relative">
            <div
              className={`${
                input.errors.inputdescription && "error-border-line"
              }`}
            >
              <CKeditorComponent
                onChange={handleCKEditor}
                value={input?.inputdescription}
                tag="inputdescription"
              />
            </div>
            {input.errors.inputdescription && (
              <p className="error-line">
                <span className="error-message-icon">
                  <img
                    src={infoIcon}
                    alt="infoIcon"
                    title={input.errors.inputdescription}
                  />
                </span>
              </p>
            )}
          </div>
        </Form.Group>
      </Col>
      <Col md={12}>
        <Form.Group className="mb-3" controlId="formProfilePic">
          <Form.Label className="common-label">
            Upload Output Sample Data (json file)
            <span className="ms-1 red-color-text">*</span>
          </Form.Label>
          <div className="position-relative">
            <div
              className={`file-input height-40 ${
                input.errors.outputsamplefile && "error-border-line"
              }`}
            >
              <label className="filelabel-browse-file w-100" for="profileImg4">
                <div className="filelabel-browse-file-inner">
                  <span>
                    {input?.outputsamplename
                      ? input?.outputsamplename
                      : "Json File"}
                  </span>
                  <div className="browse-btn-in-input">Browse</div>
                </div>
                <input
                  type="file"
                  id="profileImg4"
                  ref={OutputFileRef}
                  accept="application/json"
                  onChange={(e) =>
                    fnCommonFileChange(
                      e.target.files[0],
                      "application/json",
                      "outputsamplefile"
                    )
                  }
                />
              </label>
            </div>
            {input.errors.outputsamplefile && (
              <p className="error-line">
                <span className="error-message-icon">
                  <img
                    src={infoIcon}
                    alt="infoIcon"
                    title={input.errors.outputsamplefile}
                  />
                </span>
              </p>
            )}
          </div>
        </Form.Group>
      </Col>

      <Col md={12}>
        <Form.Group className="mb-3" controlId="formProfilePic">
          <Form.Label className="common-label">
            Output Specifications<span className="ms-1 red-color-text">*</span>
          </Form.Label>
          <div className="position-relative">
            <div
              className={`${
                input.errors.outputdescription && "error-border-line"
              }`}
            >
              <CKeditorComponent
                onChange={handleCKEditor}
                value={input?.outputdescription}
                tag="outputdescription"
              />
            </div>
            {input.errors.outputdescription && (
              <p className="error-line">
                <span className="error-message-icon">
                  <img
                    src={infoIcon}
                    alt="infoIcon"
                    title={input.errors.outputdescription}
                  />
                </span>
              </p>
            )}
          </div>
        </Form.Group>
      </Col>
      <div className="machin-detail-footer-btns">
        <button className="grey-btn" onClick={() => handleclose()}>
          Cancel
        </button>
        <button
          className="blue-btn"
          disabled={MachineLoader}
          onClick={(e) => updateReviewStatus(e)}
          // onClick={(e) => handleUpdate(e)}
          // type="submit"
        >
          {MachineLoader ? (
            // <>
            //   <span>Loading</span>{" "}
            //   <Spinner
            //     className="ms-1"
            //     animation="border"
            //     role="status"
            //     size="sm"
            //   >
            //     <span className="visually-hidden">Loading...</span>
            //   </Spinner>
            // </>
            <SubmitLoading />
          ) : (
            "Submit"
          )}
        </button>
      </div>
    </div>
  );
};

export default Specifications;
